import React from 'react';
import PropTypes from 'prop-types';

const EXPIRE_FILTER_CHIPS = [
  { id: 'all', label: 'ทั้งหมด' },
  { id: 'near', label: 'ใกล้หมดอายุ' },
  { id: 'le60', label: '≤ 60 วัน' },
  { id: 'le30', label: '≤ 30 วัน' },
];

function ShopExpireFilterChips({ value, onChange }) {
  return (
    <div className='expire-filter-chips' role='group' aria-label='กรองตามวันหมดอายุ'>
      {EXPIRE_FILTER_CHIPS.map((chip) => (
        <button
          key={chip.id}
          type='button'
          className={'expire-filter-chip' + (value === chip.id ? ' is-active' : '')}
          onClick={() => onChange(chip.id)}
        >
          {chip.label}
        </button>
      ))}
    </div>
  );
}

ShopExpireFilterChips.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ShopExpireFilterChips;
